import { styled, Typography } from "@mui/material";

export const ReferenceBookGroupTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h2,
  color: theme.palette.primary.main,
  textDecoration: "underline",
  marginBottom: "1rem",
}));
